export const environment = {
  serviceWorkerEnabled: true,
  production: true,
  apiUrl: 'service',
  logLevel: 7
};
